import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByOrder: state => orderId => {
            return state.objs.filter(oe => oe.order === orderId);
        },
        getByOrderAndProduct: state => (orderId, productId) => {
            return state.objs.filter(oe => oe.order === orderId && oe.product === productId);
        },
        getByPayment: state => paymentId => {
            return state.objs.filter(oe => oe.payment === paymentId);
        },
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}